export const WhatsappType = {
  GET_WHATSAPP_DATA: "GET_WHATSAPP_DATA",
};
